import React, { FC, useEffect, useMemo } from "react";
import SlidingIconButton from "./SlidingIconButton";
import { useStore } from "../../store/store";

const AudioButton: FC = () => {
  const { audioManager, soundEnabled, setSoundEnabled } = useStore();

  // Dynamically calculate classNames based on soundEnabled
  const classNames = useMemo(
    () =>
      soundEnabled
        ? "hover:w-[8.9rem] hover:border-sunshineYellow"
        : "hover:w-[8.6rem] hover:border-sunshineYellow",
    [soundEnabled],
  );

  const iconClass = soundEnabled ? "d-volume-up-solid" : "d-volume-off-solid";
  const buttonText = soundEnabled ? "Audio stoppen" : "Audio starten";

  useEffect(() => {
    if (audioManager) {
      const isPlaying = audioManager.isPlaying("background");
      setSoundEnabled(audioManager.enabled && isPlaying);
      audioManager.setEnabled(isPlaying);
    }
  }, [audioManager, setSoundEnabled]);

  const onClick = () => {
    const newSoundEnabled = !soundEnabled;
    setSoundEnabled(newSoundEnabled);
    audioManager?.setEnabled(newSoundEnabled);

    if (newSoundEnabled) {
      audioManager?.play("background");
    } else {
      audioManager?.stop("background");
    }
  };

  return (
    <SlidingIconButton
      color="text-white"
      text={buttonText}
      iconClass={iconClass}
      className={classNames}
      onClick={onClick}
      openByDefault={false}
      reverse={true}
      reverseAnimation={false}
    />
  );
};

export default AudioButton;
